import gql from 'graphql-tag';

export const GET_CARD_NETWORK_STATUS = gql`
  fragment cardStatus on CardNetworkDetails {
    cardNetwork
    logo
    lastAuth
    lastClear
    percentDropped
    percentDroppedTrend
  }

  fragment retrievalJobsStats on RetrievalJobsStats {
    quantity
    dateOfOldest
  }

  query getCardNetworkStatus($params: CardNetworkStatusInput!) {
    cardNetworkStatus(params: $params) {
      AMEX {
        ...cardStatus
      }

      VISA {
        ...cardStatus
      }

      MASTERCARD {
        ...cardStatus
      }
    }

    getStatsAboutRetrievalJobsWaitingForExport {
      amexStats: AMEX {
        ...retrievalJobsStats
      }

      mastercardStats: MASTERCARD {
        ...retrievalJobsStats
      }

      visaStats: VISA {
        ...retrievalJobsStats
      }
    }
  }
`;

export const GET_MERCHANT_CARD_NETWORK_STATUS = gql`
  fragment cardStatusMerchant on CardNetworkDetails {
    cardNetwork
    logo
    lastAuth
    lastClear
    percentDropped
    percentDroppedTrend
    venuesTransacting
    venuesWithTransactions
    venues
  }

  query getCardNetworkStatus($params: CardNetworkStatusInput!) {
    cardNetworkStatus(params: $params) {
      AMEX {
        ...cardStatusMerchant
      }

      VISA {
        ...cardStatusMerchant
      }

      MASTERCARD {
        ...cardStatusMerchant
      }
    }
  }
`;
